export default "__VITE_ASSET__c8d3b739__"